import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { FolderEventNames } from '../types';

type FolderEventPayload = Pick<
  TrackEventProperties,
  'folderId' | 'workspaceId' | 'workspaceName' | 'workspaceType'
>;
type EventName = keyof typeof FolderEventNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof FolderEventNames>>}`;
const functionNameEntries = Object.keys(FolderEventNames).map((eventName) => [
  eventName as EventName,
  `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
]);

export const useFolderAnalytics = (location: string) => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: FolderEventPayload) => {
        trackEvent(FolderEventNames[eventName], {
          ...payload,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload: FolderEventPayload) => void;
  };
};
